import { Injectable } from '@angular/core';
import {GoogleMapLoaderService} from './google/google-map-loader.service';
import {SclMapConstantService} from './scl-map-constant.service';
import {SclUtilMapService} from './scl-util-map.service';
import { cloneDeep } from 'lodash';

const sclUtilMapService = new SclUtilMapService();
const googleMapLoaderService = new GoogleMapLoaderService();

@Injectable({
  providedIn: 'root'
})
export class SclMapGeoGoogleService {
  constructor() { }

  autocompleteUrl = 'https://maps.googleapis.com/maps/api/place/autocomplete/json?input=';
  geocodeUrl = 'https://maps.googleapis.com/maps/api/geocode/json?latlng=';
  googleLoader = null;
  initObj;


  autocompleteBox;
  autocompleteStreet;
  waitTime = 5000; // miliseconds
  apiKey;
  apiKeyReverse;
  country;
  language;
  loadLookup = false;
  cbSelectOption;
  intervalSetupLookUp;
  intervalSetupLookUpCount = 0;

  reverse( coor, cb, cbErr, cbTimeout) {
    if (!this.apiKeyReverse) { this.apiKeyReverse = this.apiKey; }
    if (!this.apiKeyReverse) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('apiKey null');
      }
      return;
    }

    let link = this.geocodeUrl + coor[1] + ',' + coor[0] + '&key=' + this.apiKeyReverse;
    link = this.getLinkOptions( link);
    this.initObj.httpService.getAPI(link, {timeout: this.waitTime})
      .subscribe(data => {
        if (data.status === 'OK') {
          const datas = data.results[0];
          let streetData = cloneDeep(SclMapConstantService.STREET);
          streetData = sclUtilMapService.fillGoogleAddress(datas, streetData);
          if (cb && typeof cb === 'function') {
            cb(streetData, {lat: datas.geometry.location.lat, lng: datas.geometry.location.lng});
          }
        } else {
          if (cbErr && typeof cbErr === 'function') {
            let errorMsg = 'Google reverse Error';
            if (data !== null && data.error_message !== null) {
              errorMsg = data.error_message;
            }
            cbErr(errorMsg);
          }

        }
      }, err => {
        if (err.status === -1) {
          if (cbTimeout && typeof cbTimeout === 'function') {
            cbTimeout();
          }
        } else {
          // logger.info(err);
          if (cbErr && typeof cbErr === 'function') {
            cbErr('Google reverse Error');
          }
        }
      });

  }

  setupLookUp() {
    const apiKey = this.apiKey;
    googleMapLoaderService.KEY = apiKey;
    googleMapLoaderService.LIBRARIES = 'places,drawing,visualization';
    googleMapLoaderService.SENSOR = true;
    if (this.intervalSetupLookUp) {
      return;
    }
    this.intervalSetupLookUp = setInterval(() => {
      this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
      if (this.autocompleteStreet) {
        clearInterval(this.intervalSetupLookUp);
        this.intervalSetupLookUp = null;
        this.intervalSetupLookUpCount = 0; // reset
        // console.log('find autocompletebox');
        googleMapLoaderService.load().then((google: any) => {
          const autocompleteObj = new google.maps.places.Autocomplete(
            this.autocompleteStreet,
            { types: ['geocode'] });

          google.maps.event.addListener(autocompleteObj, 'place_changed', () => {
            const place = autocompleteObj.getPlace();
            let streetData = cloneDeep(SclMapConstantService.STREET);
            streetData = sclUtilMapService.fillGoogleAddress(place, streetData);
            if (this.cbSelectOption && typeof this.cbSelectOption === 'function' ) {
              this.cbSelectOption(streetData);
            }

          });
        });
      } else {
        this.intervalSetupLookUpCount++;
        if (this.intervalSetupLookUpCount > 11) {
          console.log('can\'t load google geo service because can\'t find autocomplete box');
          clearInterval(this.intervalSetupLookUp);
          this.intervalSetupLookUp = null;
          this.intervalSetupLookUpCount = 0; // reset
        } else {
          console.log('waiting for autocomplete box loading..');
        }
      }
    }, 100);
  }

  lookUp( params, cb, cbErr, cbSelectOption, cbRemoveStreet, cbTimeout ) {
    if (params == null || params.length < 1) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('params invalid. [0] : autocompleteBox');
      }
      return;
    }
    if ( this.apiKey == null ) {
      if (cbErr && typeof cbErr === 'function') {
        cbErr('apiKey is null');
      }
      return;
    }

    if (this.googleLoader === null) {
      this.autocompleteBox = params[0];

      if (!this.loadLookup) {
        this.loadLookup = true;
        this.cbSelectOption = cbSelectOption;
        this.setupLookUp();
      }
    }
  }

  removeLookUp() {
    const id = this.initObj.keyName + 'MapGeoGoogle';
    const lst = document.querySelectorAll('#' + id);
    if (lst && lst.length > 0) {
      for (let i = 0; i < lst.length; i++) {
        lst[i].remove();
      }
    }

    this.autocompleteBox = null;
    this.googleLoader = null;
  }

  removeStreet(cb) {
    if (this.autocompleteStreet == null) {
      this.autocompleteStreet = document.getElementById(this.initObj.keyName + 'autocomplete');
    }
    if (this.autocompleteStreet == null) {
      if (cb && typeof cb === 'function') {
        cb();
      }
      return;
    }
    this.autocompleteStreet.value = '';

    if (cb && typeof cb === 'function') {
      cb();
    }
  }

  getLinkOptions( link) {
    if (this.country) { link += '&country=' + this.country; }
    if (this.language) { link += '&lang=' + this.language; }

    return link;
  }

}
